import { BaseComponent, define, api } from 'core';

const STORE_KEY = 'theme:recently-viewed';
const MAX = 12;

function read() {
  try {
    const list = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch (_e) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (_e) {

  }
}

function record(handle) {
  if (!handle) return;
  const list = read().filter((h) => h !== handle);
  list.unshift(handle);
  write(list);
}

function escapeAttr(value) {
  return String(value).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export class RecentlyViewedTrack extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    record(this.dataset.handle);
  }
}

export class RecentlyViewed extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    this._limit = parseInt(this.dataset.limit, 10) || 8;
    this._exclude = this.dataset.exclude || '';
    this._render();
  }

  async _render() {
    const handles = read()
      .filter((h) => h && h !== this._exclude)
      .slice(0, this._limit);
    if (handles.length === 0) return;

    const results = await Promise.all(
      handles.map((h) => api.renderProductCard(h).catch(() => null))
    );
    const cards = results.filter((html) => html && html.trim());
    if (cards.length === 0) return;

    const heading = this.dataset.heading || '';
    // Markup "You may also like" (sections/product-recommendations.liquid) ile
    // BİREBİR aynı: aynı başlık sınıfı, aynı çıplak chevron okları, aynı nokta
    // kabı, aynı slayt sınıfları. Şerit daha önce kendi stilini taşıyordu —
    // 16px'lik .section-heading ve yuvarlak butonlu oklar — ve alt alta duran
    // iki şerit iki farklı temadan geliyormuş gibi görünüyordu.
    // py-3.5: kart hover katmanının dışa taşma payı; py-2 iken slaytı 6px aşıp
    // izi dikeyde kaydırılabilir yapıyor ve fare tekerleği carousel'de takılıyor.
    const slides = cards
      .map((html) => `<div data-carousel-slide class="cards-editorial shrink-0 snap-start py-3.5">${html}</div>`)
      .join('');

    this.innerHTML = `
      ${heading ? `<h2 class="product-section-heading mb-6 text-start">${escapeAttr(heading)}</h2>` : ''}
      <carousel-slider aria-label="${escapeAttr(heading || 'Recently viewed')}" class="recently-viewed-slider relative block" data-pagination-label="Go to page">
        <div data-carousel-track tabindex="0" class="flex snap-x snap-mandatory scroll-smooth overflow-x-auto">
          ${slides}
        </div>
        <button data-carousel-prev type="button" aria-label="Previous" class="carousel-arrow carousel-arrow--prev">‹</button>
        <button data-carousel-next type="button" aria-label="Next" class="carousel-arrow carousel-arrow--next">›</button>
        <div data-carousel-dots class="mt-6 flex items-center justify-center gap-2" role="group" aria-label="Pagination"></div>
      </carousel-slider>`;
    this.classList.remove('hidden');
    this.classList.add('block');
  }
}

define('recently-viewed-track', RecentlyViewedTrack);
define('recently-viewed', RecentlyViewed);
